import { h, Fragment } from 'preact'
import dayjs from 'dayjs'
import { useMemo } from 'preact/hooks'
import { useAppointmentManagerContext } from '../appointment-manager/appointment-manager-context'
import { useStateValue } from '../../state-management/store'
import { useLocationTimezone } from '../../shared/custom-hooks/useLocationTimezone'
import { APPOINTMENT_DATE_FORMAT, APPOINTMENT_TIME_FORMAT } from '../../shared/const'
import * as style from './style.css'

const AppointmentDetailsForWriteback: preact.FunctionalComponent = () => {
    const [{ locations, selectedLocationId, selectedAppointmentTime }] = useStateValue()

    const location = useMemo(() => locations.find((l) => l.id === selectedLocationId), [locations, selectedLocationId])
    const { shortTimezone } = useLocationTimezone(location)

    const renderTime = () => {
        const selectedDateTime = selectedAppointmentTime.slice(0, selectedAppointmentTime.length - 7)

        return `${dayjs(selectedDateTime).format(APPOINTMENT_DATE_FORMAT)}, ${dayjs(selectedDateTime).format(
            APPOINTMENT_TIME_FORMAT
        )} ${shortTimezone}`
    }

    if (!location) {
        return <Fragment />
    }

    return (
        <Fragment>
            <span class={style.apptDetailsDatetime}>{renderTime()}</span>
            <span class={style.apptDetailsHelperText}>{location.name}</span>
            <span class={style.apptDetailsHelperText}>{`${location.street}${
                location.street && location.unit ? `, ${location.unit}` : ''
            }`}</span>
            <span class={style.apptDetailsHelperText}>{`${location.city}${
                location.city && location.zip ? `, ${location.state ? `${location.state} ` : ''}${location.zip}` : ''
            }`}</span>
            <span class={style.apptDetailsHelperText} style={{ marginBottom: '12px' }}>
                {location.phoneNumber}
            </span>
        </Fragment>
    )
}

export default AppointmentDetailsForWriteback
